module.exports = __webpack_public_path__ + "img/portalmanagement_check_interdictions.31517c39.png";